import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
  standalone: true, // 🔹 clave para standalone
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  imports: [RouterOutlet, HeaderComponent, FooterComponent], // 🔹 importás aquí lo que usás en el HTML
})
export class MainLayoutComponent {}
